/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
export const DecimalSchema = z.any().refine((val) => {
    if (typeof val === 'string' || typeof val === 'number') {
        return true;
    }
    // Decimal.js shape
    if (typeof val === 'object' && val && Array.isArray(val.d) && typeof val.e === 'number' && typeof val.s === 'number') {
        return true;
    }
    return false;
}, { message: 'Not a valid Decimal value' });
